import script from "./Template5.vue?vue&type=script&setup=true&lang=ts"
export * from "./Template5.vue?vue&type=script&setup=true&lang=ts"

import "./Template5.vue?vue&type=style&index=0&id=ae736830&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae736830"]])

export default __exports__